import { Expose } from "@nts/std/serialization";
import { AutoCompleteOptions } from './auto-complete-options';
import { AutoCompleteExternalOptionsInterface } from "@nts/std/interfaces";

export class AutoCompleteExternalOptions extends AutoCompleteOptions implements AutoCompleteExternalOptionsInterface {

    /**
     * Full name dell'external per cui si vuole eseguire l'autocomplete
     */
    @Expose()
    fullRootModelName: string;

}
